window.addEventListener('resize', reBorder, false);
document.addEventListener("DOMContentLoaded", removeBorder);

function removeBorder() {
    var grids = document.querySelectorAll(".nav__container .row");

    [].forEach.call(grids, function (row) {
        var pseudoRows = [];

        var i = -1;
        var items = row.querySelectorAll("div");
        [].forEach.call(items, function (item) {
            var pos = item.offsetLeft - row.offsetLeft;
            if (pos < 50) {
                i++;
                pseudoRows.push({ key: i, cols: [] });
            }
            pseudoRows[i].cols.push(item);
        });

        [].forEach.call(pseudoRows[i].cols, function (item) {
            item.style.border = '0';
        });

    });
}
function reBorder() {
    clearStyles();
    removeBorder();
}
function clearStyles() {
    var items = document.querySelectorAll(".nav__container .row > div");
    [].forEach.call(items, function (item) {
        item.removeAttribute("style");
    });
}


// WEBPACK FOOTER //
// ./Components/Shared/menu.js